// Provides TiptapDocumentSB helpers with callbacks that keep stable identity while calling the latest implementation.
import React from "react";

/**
 * Returns a callback with a stable function identity whose body is refreshed after every render.
 * This preserves class-style method semantics for long-lived listeners, timers, and child props.
 */
export function useStableCallback<TArgs extends unknown[], TResult>(callback: (...args: TArgs) => TResult): (...args: TArgs) => TResult {
  const callbackRef = React.useRef(callback);

  React.useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return React.useCallback((...args) => callbackRef.current(...args), []);
}
